(function() {
    const element = document.querySelector('.hotel-limeform');
    const getPath = window.location.pathname;
    const page = getPath.split('/').filter(Boolean);
    const pageLast = page[page.length - 1];

    if (pageLast != null) {
        const url = pageLast.replace(/-/g, ' ');
        try {
            if (element) {
                const hotelFormID = 'yGifMkNUwtqU2uQn5O7j';

                window.waitForDeferred(
                    'lime-forms',
                    function() {
                        return window.limeForms != null;
                    },
                    function() {
                        const formsApi = window.limeForms.getApi(hotelFormID);

                        formsApi.onReady(function() {
                            formsApi.setFieldValue('location', url);
                        });
                    },
                );
            }
        } catch (ex) {
            console.error(ex); // Log any potential errors
        }

    }
})();
